export var ENTITY = "export-file";
export var REDUCER_KEY = "EXPORT_FILE";
export var BASE_PATH_ENTITY = "export-files";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
